const SITE_URL = 'https://hvkurz.de';
const COMPANY_NAME = 'Scholze-Kurz & Kurz Immobilien GmbH';
const LOGO_URL = `${SITE_URL}/images/logo.png`;
const OFFICE_IMAGE_URL = `${SITE_URL}/images/buero-mainz.png`;

// Externe Profile / Verzeichnis-Einträge (sameAs für Google Knowledge Graph).
// Diese Liste signalisiert Google, dass es sich um EIN konsistentes Unternehmen
// handelt und stärkt die Local-SEO-Authorität. Profile, die noch nicht existieren,
// können einfach aus diesem Array ausgenommen werden.
const SAME_AS_PROFILES = [
  // Google Business Profile (anpassen sobald GBP-URL feststeht)
  'https://maps.app.goo.gl/SCHOLZE-KURZ-WIESBADEN',
  // Branchenverzeichnisse
  'https://www.werkenntdenbesten.de/dienstleister/scholze-kurz-kurz-immobilien-gmbh-/Wiesbaden',
  'https://www.gelbeseiten.de/Suche/Hausverwaltung/Wiesbaden/Scholze-Kurz',
  'https://www.dasoertliche.de/?form_name=search_nat&kw=Scholze-Kurz',
  'https://www.hausverwaltersuche.de/profil/scholze-kurz-kurz-immobilien',
  // Social Media (sobald gepflegt)
  // 'https://www.facebook.com/hvkurz',
  // 'https://www.linkedin.com/company/scholze-kurz-kurz-immobilien',
  // 'https://www.xing.com/companies/scholze-kurz-kurz-immobilien-gmbh',
];

const locationWiesbaden = {
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#office-wiesbaden`,
  name: `${COMPANY_NAME} - Hauptsitz Wiesbaden-Biebrich`,
  image: OFFICE_IMAGE_URL,
  telephone: '+49-611-603313',
  email: 'info@hvkurz.de',
  url: SITE_URL,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Gaugasse 19',
    addressLocality: 'Wiesbaden',
    addressRegion: 'Hessen',
    postalCode: '65203',
    addressCountry: 'DE',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 50.0399,
    longitude: 8.2362,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
};

const locationMainzKostheim = {
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#office-mainz-kostheim`,
  name: `${COMPANY_NAME} - Geschäftsstelle Mainz-Kostheim`,
  image: OFFICE_IMAGE_URL,
  telephone: '+49-6134-2863266',
  email: 'info@hvkurz.de',
  url: SITE_URL,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Hauptstraße 127',
    addressLocality: 'Mainz-Kostheim',
    addressRegion: 'Hessen',
    postalCode: '55246',
    addressCountry: 'DE',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 50.0071,
    longitude: 8.2922,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
};

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    '@id': `${SITE_URL}/#organization`,
    name: COMPANY_NAME,
    alternateName: 'Hausverwaltung Scholze-Kurz & Kurz',
    url: SITE_URL,
    logo: LOGO_URL,
    image: OFFICE_IMAGE_URL,
    description: 'Hausverwaltung in Wiesbaden seit 1981 – Zertifizierter Verwalter (IHK) gemäß § 26a WEG. WEG-Verwaltung, Mietverwaltung und Sondereigentumsverwaltung in der Rhein-Main-Region.',
    foundingDate: '1981',
    telephone: '+49-611-603313',
    email: 'info@hvkurz.de',
    numberOfEmployees: { '@type': 'QuantitativeValue', minValue: 5, maxValue: 15 },
    areaServed: [
      { '@type': 'City', name: 'Wiesbaden' },
      { '@type': 'City', name: 'Mainz' },
      { '@type': 'City', name: 'Idstein' },
      { '@type': 'AdministrativeArea', name: 'Rhein-Main-Gebiet' },
    ],
    address: locationWiesbaden.address,
    location: [locationWiesbaden, locationMainzKostheim],
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'Zertifizierter Verwalter (IHK) gemäß § 26a WEG',
      recognizedBy: { '@type': 'Organization', name: 'IHK Wiesbaden' },
    },
    sameAs: SAME_AS_PROFILES,
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: `${COMPANY_NAME} - Hausverwaltung Wiesbaden`,
    publisher: { '@id': `${SITE_URL}/#organization` },
    inLanguage: 'de-DE',
  };
}

export function getLocalBusinessSchema(location) {
  if (location === 'wiesbaden') {
    return { '@context': 'https://schema.org', ...locationWiesbaden };
  }
  if (location === 'mainz-kostheim') {
    return { '@context': 'https://schema.org', ...locationMainzKostheim };
  }
  return null;
}

export function getBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url ? `${SITE_URL}${item.url}` : undefined,
    })),
  };
}

export function getServiceSchema({ name, description, url, areaServed, provider }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    url: `${SITE_URL}${url}`,
    provider: provider || { '@id': `${SITE_URL}/#organization` },
    areaServed: areaServed || [
      { '@type': 'City', name: 'Wiesbaden' },
      { '@type': 'City', name: 'Mainz' },
      { '@type': 'AdministrativeArea', name: 'Rhein-Main-Gebiet' },
    ],
    serviceType: 'Immobilienverwaltung',
  };
}

export function getFAQSchema(faqs) {
  if (!faqs || faqs.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

/**
 * Enhanced LocalBusiness Schema with multiple locations
 * Optimized for local SEO (Google Maps, Local Pack)
 */
export function getEnhancedLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    '@id': `${SITE_URL}/#localbusiness`,
    name: COMPANY_NAME,
    alternateName: ['HV Kurz', 'Hausverwaltung Scholze-Kurz', 'Scholze-Kurz & Kurz'],
    description: 'Hausverwaltung in Wiesbaden seit 1981 – Zertifizierter Verwalter (IHK) gemäß § 26a WEG. WEG-Verwaltung, Mietverwaltung und Sondereigentumsverwaltung in der Rhein-Main-Region.',
    url: SITE_URL,
    logo: LOGO_URL,
    image: [OFFICE_IMAGE_URL, LOGO_URL],
    telephone: '+49-611-603313',
    email: 'info@hvkurz.de',
    foundingDate: '1981',
    priceRange: '$$',
    currenciesAccepted: 'EUR',
    paymentAccepted: ['Überweisung', 'Lastschrift', 'SEPA'],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Gaugasse 19',
      addressLocality: 'Wiesbaden',
      addressRegion: 'Hessen',
      postalCode: '65203',
      addressCountry: 'DE',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 50.0399,
      longitude: 8.2362,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '17:00',
      },
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+49-611-603313',
        contactType: 'customer service',
        areaServed: 'DE',
        availableLanguage: 'German',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '14:00',
        },
      },
      {
        '@type': 'ContactPoint',
        telephone: '+49-6134-2863266',
        contactType: 'customer service',
        areaServed: 'DE',
        availableLanguage: 'German',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '14:00',
        },
      },
    ],
    areaServed: [
      { '@type': 'City', name: 'Wiesbaden', sameAs: 'https://de.wikipedia.org/wiki/Wiesbaden' },
      { '@type': 'City', name: 'Mainz', sameAs: 'https://de.wikipedia.org/wiki/Mainz' },
      { '@type': 'City', name: 'Idstein' },
      { '@type': 'City', name: 'Hochheim am Main' },
      { '@type': 'City', name: 'Taunusstein' },
      { '@type': 'City', name: 'Eltville am Rhein' },
      { '@type': 'City', name: 'Bad Schwalbach' },
      { '@type': 'City', name: 'Oppenheim' },
      { '@type': 'City', name: 'Rüsselsheim' },
      { '@type': 'City', name: 'Flörsheim am Main' },
      { '@type': 'AdministrativeArea', name: 'Rhein-Main-Gebiet' },
      { '@type': 'AdministrativeArea', name: 'Rheingau-Taunus-Kreis' },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Hausverwaltungsleistungen',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'WEG-Verwaltung',
            description: 'Professionelle Verwaltung von Wohnungseigentümergemeinschaften gemäß Wohnungseigentumsgesetz (WEG)',
            url: `${SITE_URL}/weg-verwaltung`,
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Mietverwaltung',
            description: 'Umfassende Betreuung von Mietimmobilien und Renditeoptimierung',
            url: `${SITE_URL}/mietverwaltung`,
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Sondereigentumsverwaltung',
            description: 'Individuelle Verwaltung von Eigentumswohnungen als Kapitalanlage',
            url: `${SITE_URL}/sondereigentumsverwaltung`,
          },
        },
      ],
    },
    hasCredential: [
      {
        '@type': 'EducationalOccupationalCredential',
        credentialCategory: 'Zertifizierter Verwalter (IHK) gemäß § 26a WEG',
        recognizedBy: { '@type': 'Organization', name: 'IHK Wiesbaden' },
      },
    ],
    knowsAbout: [
      'WEG-Verwaltung',
      'Wohnungseigentumsgesetz',
      'Mietverwaltung',
      'Betriebskostenabrechnung',
      'Eigentümerversammlung',
      'Hausgeldabrechnung',
      'Instandhaltungsplanung',
    ],
    sameAs: SAME_AS_PROFILES,
  };
}

export function getBlogPostingSchema({ title, description, datePublished, author, url, image }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    datePublished,
    author: { '@type': 'Person', name: author },
    publisher: { '@id': `${SITE_URL}/#organization` },
    url: `${SITE_URL}${url}`,
    image: image || LOGO_URL,
    inLanguage: 'de-DE',
  };
}

export function getProfessionalServiceSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${SITE_URL}/#professional-service`,
    name: COMPANY_NAME,
    url: SITE_URL,
    image: LOGO_URL,
    description: 'Zertifizierter Verwalter (IHK) gemäß § 26a WEG. Hausverwaltung in Wiesbaden seit 1981.',
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'Zertifizierter Verwalter (IHK) gemäß § 26a WEG',
      recognizedBy: { '@type': 'Organization', name: 'IHK Wiesbaden' },
    },
    areaServed: [
      { '@type': 'City', name: 'Wiesbaden' },
      { '@type': 'City', name: 'Mainz' },
      { '@type': 'AdministrativeArea', name: 'Rhein-Main-Gebiet' },
    ],
    address: locationWiesbaden.address,
    telephone: '+49-611-603313',
  };
}
